"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const FooterLink = ({
  ifexists,
  ...props
}) => {
  return ifexists && !props.href ? null : (0, _jsxRuntime.jsx)(_styles.Wrapper, {
    ...props,
    href: props.href,
    textAlign: "left",
    children: props.children
  });
};
var _default = exports.default = FooterLink;